export const EHSActionTypes = {
  GET_ALL_EHS_DATA: 'GET_ALL_EHS_DATA',
  FILTERED_EHS_DATA: 'FILTERED_EHS_DATA',
  EHS_PUBLICATION_DATA: 'EHS_PUBLICATION_DATA',

  EHS_SEARCH_DATA: 'EHS_SEARCH_DATA',
  EHS_SEARCH_LAST_QUERY: 'EHS_SEARCH_LAST_QUERY',
};
